import { render, staticRenderFns } from "./ValidEmployPhoneNumber.vue?vue&type=template&id=4fdd490e&scoped=true&"
import script from "./ValidEmployPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ValidEmployPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./ValidEmployPhoneNumber.vue?vue&type=style&index=0&id=4fdd490e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd490e",
  null
  
)

export default component.exports